import {maskPhone} from '@raison/ui-kit';
import type {ValidatePhoneNumberLengthResult} from 'libphonenumber-js';
import {formatIncompletePhoneNumber, parseIncompletePhoneNumber, validatePhoneNumberLength} from 'libphonenumber-js';

const invalidCharsRE = /[^\d\s]/g;

const stripInvalidChars = (phone: Username.Value) => {
    return phone.replace(invalidCharsRE, '');
};

const basePhoneValidation = (phone: Username.Value) => {
    if ('' === phone.replace('+', '').trim()) return 'REQUIRED';
};

const ensureStartsWithPlus = (phone: Username.Value) => {
    if (phone[0] === '+') {
        return phone;
    }
    return `+${phone}`;
};

export class Username {
    static empty() {
        return new Username('+');
    }

    static fromString(anyString: string) {
        anyString = stripInvalidChars(anyString);
        anyString = ensureStartsWithPlus(anyString);
        const phoneString = formatIncompletePhoneNumber(anyString);
        return new Username(phoneString);
    }

    toString() {
        return this.__cachedRawValue ?? (this.__cachedRawValue = parseIncompletePhoneNumber(this.__formattedValue));
    }

    get formatted() {
        return this.__formattedValue;
    }

    get masked() {
        return maskPhone(this.formatted);
    }

    get validationError(): Username.ValidationResult | undefined {
        return (
            this.__cachedError ??
            (this.__cachedError = basePhoneValidation(this.toString()) || validatePhoneNumberLength(this.toString()))
        );
    }

    get isValid() {
        return !this.validationError;
    }

    get length() {
        return this.toString().length - '+'.length;
    }

    private __cachedRawValue: string | undefined;
    private __cachedError: Username.ValidationResult | undefined;

    private constructor(private readonly __formattedValue: Username.Value) {}
}

export namespace Username {
    export type Value = string;
    export type SimpleValidationResult = ReturnType<typeof basePhoneValidation>;
    export type ValidationResult = ValidatePhoneNumberLengthResult | SimpleValidationResult;
}
